import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=409b2457&scoped=true&"
import script from "./TextBlock.vue?vue&type=script&lang=js&"
export * from "./TextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409b2457",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('409b2457')) {
      api.createRecord('409b2457', component.options)
    } else {
      api.reload('409b2457', component.options)
    }
    module.hot.accept("./TextBlock.vue?vue&type=template&id=409b2457&scoped=true&", function () {
      api.rerender('409b2457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v1/renderer/TextBlock.vue"
export default component.exports